import { Icons } from "assets";
import classNames from "classnames";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import { toastMessage } from "shared/components/common/toast";
import { setAuthReducer } from "shared/redux/reducers/authSlice";
import { routeConstant } from "shared/routes/routeConstant";
import { LoginService } from "shared/services/auth";
import { LoginVS } from "shared/utils/validation";
import styles from "./styles.module.scss";
import { handleErrors } from "shared/utils/helper";

const initialValues: LoginType = {
  email: "",
  password: "",
};

const Login = () => {
  const dispatch = useDispatch();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: LoginVS,
    onSubmit: (value, action) => {
      handleLogin();
    },
  });

  const {
    handleChange,
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
    resetForm,
  } = formik;

  const handleLogin = () => {
    setSubmitting(true);
    LoginService(values)
      .then(({ data, status }) => {
        if (status) {
          resetForm();

          dispatch(
            setAuthReducer({
              isLoggedIn: true,
              user: {
                email: data?.data?.email,
                fullname: data?.data?.fullname,
              },
              token: data?.data?.token,
            })
          );

          toastMessage("success", "Logged In Successfully");
        }
      })
      .catch((err: any) => {
        handleErrors(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <main className={classNames(styles.customContainer)}>
      <div className={classNames(styles.mainContainer, "py-5")}>
        <section
          className={classNames(
            "w-full flex flex-col items-center  relative ",
            styles.leftContainer
          )}
        >
          <Link
            to={routeConstant.login.path}
            className={classNames(styles.logoContainer)}
          >
            <Icons.Logo />
          </Link>
          <div
            className={classNames(
              "flex items-center w-full justify-center m-auto"
            )}
          >
            <form
              className={classNames(styles.formContainer)}
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className={classNames("flex flex-col items-start gap-3")}>
                <h1 className={classNames(styles.title)}>Welcome</h1>
                <p className={classNames(styles.subTitle)}>
                  Please log in to access.
                </p>
              </div>
              <div className={classNames("flex flex-col gap-1")}>
                <CustomInput
                  label="Email"
                  placeholder="Enter your email"
                  required
                  Icon={Icons.Mail}
                  type="email"
                  value={values.email}
                  error={touched.email && errors.email ? errors.email : ""}
                  onChange={handleChange("email")}
                  customLabelStyle={classNames(styles.labelStyle)}
                />
                <CustomInput
                  label="Password"
                  placeholder="Enter your password"
                  required
                  isPassword
                  Icon={Icons.Lock}
                  type="password"
                  value={values.password}
                  error={
                    touched.password && errors.password ? errors.password : ""
                  }
                  onChange={handleChange("password")}
                  customLabelStyle={classNames(styles.labelStyle)}
                />
              </div>
              <div className={classNames("flex flex-col items-center gap-6")}>
                <CustomButton
                  title="Log In"
                  style={{ width: "100%" }}
                  onClick={() => handleSubmit()}
                  loading={isSubmitting}
                  disabled={isSubmitting}
                />
              </div>
            </form>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Login;
